var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"border-bottom p-1 text-right"},[_c('b-btn',{attrs:{"variant":"default","pill":"","to":{
        name: 'project-folder-default-create',
        params: {
          isType: _vm.$route.params.type
        }
      }}},[_vm._v("\n      新規作成\n    ")])],1),_c('div',{staticClass:"main"},[_c('ProjectFolderDefaultTable',{attrs:{"items":_vm.initKeys,"isType":_vm.$route.params.type},on:{"remove":_vm.remove,"sort":_vm.sort}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }